

import seoTags from "@/mixins/seoTags";

export default {
	mixins: [seoTags],
	// validate(ctx) {
	// 	return ctx.params.category === 'cars';
	// },
	mounted() {
		window.scrollTo(0, -100)
		if (!this.$device.isMobile) {
			// setTimeout(function () { window.scrollTo(0, 180); }, 2);
		}
	},
}
